var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    transform: "translate(461.235 607.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    transform: "translate(0 5.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7187",
    className: "st0",
    d: "M-457-603.9c-1.9,3.4-0.7,8.6,1.4,11.8c1.1,1.6,2.1,3,3.6,3h0.1c0.6,0,1.1-0.2,1.7-0.5 c0.6-0.3,1.3-0.5,2-0.5c0.7,0,1.3,0.2,1.9,0.5c0.6,0.3,1.2,0.4,1.8,0.4c1.6,0,2.7-1.6,3.6-2.9c0.7-1,1.2-2.1,1.6-3.3l0,0 c0-0.1,0-0.2-0.1-0.2l0,0c-1.8-0.8-2.9-2.5-2.9-4.5c0-1.7,0.9-3.3,2.3-4.2l0,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1 c-0.9-1.4-2.5-2.3-4.2-2.4c-0.1,0-0.2,0-0.4,0c-0.9,0.1-1.8,0.3-2.6,0.7c-0.4,0.2-0.8,0.3-1.3,0.4c-0.5-0.1-0.9-0.2-1.3-0.4 c-0.7-0.3-1.5-0.6-2.3-0.6h-0.1C-454.3-606.9-456.1-605.7-457-603.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    transform: "translate(8.944 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7188",
    className: "st0",
    d: "M-453.2-607c-1.3,0.1-2.6,0.8-3.5,1.8c-0.9,1-1.3,2.3-1.2,3.7c0,0.1,0.1,0.2,0.2,0.2 c0.1,0,0.2,0,0.2,0c1.3-0.1,2.5-0.7,3.3-1.7c0.9-1,1.3-2.4,1.2-3.8C-453-606.9-453.1-607-453.2-607z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.cee5b910801ab1feaa6ac5d31a90753d.svg";
export { ForwardRef as ReactComponent };